export default __webpack_public_path__ + "static/media/download_desktop.819edf9a.png";